export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7713.a1abbf07.jpg";